class Redirect {
  constructor(element) {
    this.element = element;
    const input = element.querySelector('.js-redirect');

    if (input !== null) {
      this.url = input.value;
    }

    this.doRedirect = this.doRedirect.bind(this);
  }

  doRedirect() {
    if (this.url !== undefined && this.url !== null && this.url !== '') {
      window.location.href = this.url;
    }
  }
}

if (document.querySelector('.js-competition-form') !== null) {
  const prm = Sys.WebForms.PageRequestManager.getInstance();
  if (prm != null) {
    prm.add_endRequest(handlePostback);
  }
}

function handlePostback() {
  const form = document.querySelector('.js-competition-form-confirmation');
  if (form !== null) {
    const redirect = new Redirect(form);
    setTimeout(redirect.doRedirect, 3000);
  }
}
